import { Link } from 'react-router-dom'
import { Users } from 'lucide-react'

import Card from './Card'
import BannerImage from './BannerImage'

interface Props {
  team: wowaudit.TeamReference
}

const TeamCard = ({ team }: Props) => {
  return (
    <Link
      to={team.path}
      state={{ teamReference: team, guildReference: team.ownerReference }}
      className='group block'
    >
      <Card className='flex w-full items-center gap-2 p-2 transition-colors group-hover:border-primary/40'>
        <BannerImage
          size='small'
          faction={team.ownerReference.faction}
          fileName={team.ownerReference.bannerFilename}
          className='shrink-0 rounded-md'
        />
        <div className='flex min-w-0 flex-col'>
          <span className='truncate text-sm font-medium'>
            {team.ownerReference.name}
          </span>
          <span className='truncate text-xs text-muted-foreground'>
            {team.name}
          </span>
        </div>
        <span className='ml-auto flex shrink-0 items-center gap-1.5 text-sm text-muted-foreground'>
          <Users className='h-4 w-4' />
          {team.characterAmount}
        </span>
      </Card>
    </Link>
  )
}

export default TeamCard
